import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isFunction } from 'lodash';
import { Popover, ButtonGroup, Button, OverlayTrigger } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  downloadCSV,
  // downloadPNG,
  downloadXLS,
  downloadTableQuery,
  downloadCSV2XLS
} from '../../utils/export';
import { LoadingSpinner } from '../LoadingSpinner';
import InfoModal from '../Modal/InfoModal';

const ModuleExport = ({
  showTitle,
  tableDataDownload,
  fetchData,
  data,
  // dataElement,
  title,
  csv,
  xls,
  // png,
  tableClassName,
  customDownloadFunc,
  csv2xls
}) => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  const handleDownloadDone = () => {
    setLoading(false);
    setErrorMessage(false);
    const table = document.getElementsByClassName(tableClassName)[0];
    if (table) {
      table.classList.remove('chart-exportable');
    }
  };

  const handleDownloadError = e => {
    setLoading(false);
    setErrorMessage(e);
  };

  const gatherData = (dataSource, t, callback) => {
    if (isFunction(dataSource)) {
      const result = dataSource();
      if (result) {
        if (isFunction(result.then)) {
          result
            .then(res =>
              callback(
                res,
                `CVMi_${t}`,
                handleDownloadDone,
                handleDownloadError
              )
            )
            .catch();
        } else {
          callback(
            result,
            `CVMi_${t}`,
            handleDownloadDone,
            handleDownloadError
          );
        }
      }
    } else {
      callback(
        dataSource,
        `CVMi_${t}`,
        handleDownloadDone,
        handleDownloadError
      );
    }
  };

  const handleClickOption = (downloadFunction, dataToDownload, type) => {
    if (type && type === 'png') {
      const table = document.getElementsByClassName('ReactTable')[0];
      if (table) {
        table.classList.add('chart-exportable');
      }
    }

    document.body.click();
    setLoading(true);
    setErrorMessage(false);
    gatherData(dataToDownload, `CVMi_${showTitle}`, downloadFunction);
  };

  const handleDownload = async type => {
    try {
      document.body.click();
      setLoading(true);
      setErrorMessage(false);
      let downloadSuccess;
      if (customDownloadFunc) {
        downloadSuccess = await tableDataDownload(type, showTitle);
      } else {
        downloadSuccess = await tableDataDownload(
          downloadTableQuery,
          type,
          showTitle
        );
      }

      if (downloadSuccess) {
        setLoading(false);
        setErrorMessage(false);
      } else {
        handleDownloadError('Failed to download file.');
      }
    } catch (e) {
      console.log(e);
    }
  };

  const popoverClickRootClose = () => (
    <Popover
      id="popover-trigger-click-root-close"
      title={title}
      className="tvt-module-export__popover"
      placement="right"
    >
      <ButtonGroup className="tvt-module-export__btn-group">
        {csv && (
          <Button
            onClick={() =>
              fetchData
                ? handleDownload('csv')
                : handleClickOption(downloadCSV, data)
            }
            className="tvt-module-export__btn"
          >
            <span className="tvt-module-export__btn-label">CSV</span>
          </Button>
        )}
        {xls && (
          <Button
            onClick={() =>
              fetchData
                ? handleDownload('xlsx')
                : handleClickOption(
                    csv2xls ? downloadCSV2XLS : downloadXLS,
                    data
                  )
            }
            className="tvt-module-export__btn"
          >
            <span>XLSX</span>
          </Button>
        )}
        {/* {png && ( // keep this commented until png exporting is fixed (library is broken as of 7/20/2020)
          <Button
            onClick={() => handleClickOption(downloadPNG, dataElement, 'png')}
            className="tvt-module-export__btn"
          >
            <span>PNG</span>
          </Button>
        )} */}
      </ButtonGroup>
    </Popover>
  );

  return (
    <>
      {loading ? (
        <div className="tvt-module-export">
          <LoadingSpinner />
        </div>
      ) : (
        <>
          <InfoModal
            title="Error"
            isOpen={!!errorMessage}
            onClose={handleDownloadDone}
          >
            {errorMessage}
          </InfoModal>
          <OverlayTrigger
            trigger="click"
            rootClose
            placement="bottom"
            overlay={popoverClickRootClose()}
          >
            <Button className="tvt-module-export">
              <FontAwesomeIcon icon="download" />
            </Button>
          </OverlayTrigger>
        </>
      )}
    </>
  );
};

ModuleExport.propTypes = {
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  dataElement: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func]),
  title: PropTypes.string,
  showTitle: PropTypes.string,
  csv: PropTypes.bool,
  xls: PropTypes.bool,
  png: PropTypes.bool,
  fetchData: PropTypes.bool,
  tableDataDownload: PropTypes.func,
  tableClassName: PropTypes.string,
  query: PropTypes.shape({
    queryId: PropTypes.string,
    queryMeta: PropTypes.shape({}),
    queryFilters: PropTypes.shape({})
  }),
  customDownloadFunc: PropTypes.bool
};

ModuleExport.defaultProps = {
  data: null,
  dataElement: null,
  title: '',
  showTitle: '',
  csv: false,
  png: false,
  xls: false,
  fetchData: false,
  tableDataDownload: () => {},
  tableClassName: 'ReactTable',
  query: {},
  customDownloadFunc: false
};

export default ModuleExport;
